module.exports = "<app-input-field\n  [form]=\"form\"\n  type=\"number\"\n  [id]=\"id\"\n  [controlName]=\"controlName\"\n  [key]=\"key\"\n  [class]=\"class\"\n  [min]=\"min\"\n  [max]=\"max\"\n  [minlength]=\"minlength\"\n  [maxlength]=\"maxlength\"\n  [isInteger]=\"true\"\n  [hideErrors]=\"hideErrors\"\n  [hideLabel]=\"hideLabel\"\n></app-input-field>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/input-integer-field/input-integer-field.component.html
// module id = ../../../../../src/app/shared/components/forms/input-integer-field/input-integer-field.component.html
// module chunks = main